import React, { useState } from 'react';

const AddUserModal = ({ onClose, onAddUser, loading }) => {
const [newUserEmail, setNewUserEmail] = useState('');
const [newUserName, setNewUserName] = useState('');
const [validationError, setValidationError] = useState('');

const handleSubmit = async (e) => {
  e.preventDefault();
  setValidationError('');
    
  if (!newUserEmail.trim()) {
    setValidationError('Email is required');
    return;
  }

  if (!newUserEmail.includes('@')) {
    setValidationError('Please enter a valid email address');
    return;
  }

  if (!newUserName.trim()) {
    setValidationError('Display Name is required');
    return;
  }

    try {
      await onAddUser(
        newUserEmail.trim(), 
        newUserName.trim()
      );
      // If successful, the parent will handle closing the modal
      setNewUserEmail('');
      setNewUserName('');
      onClose();
    } catch (err) {
      // Error is handled by parent component
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '550px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0, color: '#333', fontSize: '1.5rem' }}>Add New User</h2>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="userEmail" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
              Email Address *
            </label>
            <input
              id="userEmail"
              type="email"
              value={newUserEmail}
              onChange={(e) => setNewUserEmail(e.target.value)}
              placeholder="user@example.com"
              required
              disabled={loading}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '1rem'
              }}
            />
          </div>

          <div className="form-group" style={{ marginBottom: '1.5rem' }}>
            <label htmlFor="userName" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#495057' }}>
              Display Name *
            </label>
            <input
              id="userName"
              type="text"
              value={newUserName}
              onChange={(e) => setNewUserName(e.target.value)}
              placeholder="John Doe"
              required
              disabled={loading}
              style={{ 
                width: '100%', 
                padding: '0.75rem', 
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '1rem'
              }}
            />
          </div>

          {/* Validation Error */}
          {validationError && (
            <div style={{
              marginBottom: '1rem',
              padding: '1rem',
              background: '#fee2e2',
              border: '1px solid #fca5a5',
              borderRadius: '6px'
            }}>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#991b1b', fontWeight: '600' }}>
                {validationError}
              </p>
            </div>
          )}

          {/* Info Box */}
          <div style={{ 
            marginBottom: '1.5rem', 
            padding: '1rem', 
            background: '#e8f4fd', 
            border: '1px solid #bee5eb',
            borderRadius: '6px'
          }}>
            <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#0c5460', fontWeight: 'bold' }}>
              User Account Types
            </p>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#0c5460' }}>
              Users can be added with their Microsoft Work or School, Outlook, Google, or Apple email addresses.
            </p>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={loading}
            >
              {loading ? 'Adding User...' : 'Add User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
